import React, { useState } from 'react';

const Header = ({ cartCount, onCartClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-inner">
          <img width="100" height="auto" src="img/logo.jpg" alt="Monxuan Logo" className="logo" />  
          
          <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
            <ul>
              <li><a href="#home" onClick={handleLinkClick}>Головна</a></li>
              <li><a href="#about" onClick={handleLinkClick}>Про нас</a></li>
              <li><a href="#shop" onClick={handleLinkClick}>Магазин</a></li>
              <li><a href="#feedback" onClick={handleLinkClick}>Відгуки</a></li>
              <li><a href="#contact" onClick={handleLinkClick}>Контакти</a></li>
            </ul>
          </nav>

          <div className="header-actions">
            <button className="menu-toggle" onClick={toggleMenu}>
              ☰
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;